import React from "react";
import TextField from "@mui/material/TextField";

function TextfieldComponent({
  onChange,
  InputProps = {},
  sx,
  error,
  multiline,
  ...props
}) {
  return (
    <TextField
      variant="outlined"
      fullWidth
      placeholder={props.placeholder}
      onChange={onChange}
      multiline={multiline}
      rows={multiline ? 4 : 1}
      InputProps={{
        ...InputProps, // Merge external InputProps
        sx: {
          height: { md: "40px", xs: "28px" },
          padding: { md: "4px 10px", xs: "10px 10px" },
          fontSize: { md: "14px", xs: "12px" },
          background: "none !important",
          color: "#fff !important",
          borderRadius: "8px",
          "& fieldset": {
            borderColor: "#ee8e4c !important",
          },
          "& input:-webkit-autofill": {
            boxShadow: "0 0 0px 1000px transparent inset !important",
            WebkitTextFillColor: "#fff !important",
            caretColor: "#fff !important",
            transition: "background-color 5000s ease-in-out 0s",
          },
          "& input:-webkit-autofill:focus": {
            boxShadow: "0 0 0px 1000px transparent inset !important",
            WebkitTextFillColor: "#fff !important",
          },
          "& input:-internal-autofill-selected": {
            backgroundColor: "transparent !important",
          },
        },
      }}
      sx={{
        borderRadius: "8px",
        ...sx, // Merge external sx styles
      }}
      {...props}
    />
  );
}

export default TextfieldComponent;
